import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Stack, styled } from '@mui/material';
var DrawerHeader = function (_a) {
    var logo = _a.logo;
    var LogoRender = useMemo(function () {
        return styled(logo)(function (_a) {
            var theme = _a.theme;
            return ({
                path: {
                    fill: theme.palette.mode === 'dark' &&
                        theme.palette.secondary.contrastText,
                },
                width: '58px',
                height: '16px',
            });
        });
    }, [logo]);
    return (_jsx(Stack, { direction: "row", justifyContent: "space-between", sx: {
            width: 1,
            padding: '24px 18px 20px 18px',
            alignItems: 'center',
            height: '74px',
        }, spacing: 1.2, children: _jsx(LogoRender, {}) }));
};
export default DrawerHeader;
